<app-small-spinner [show]="showSpinner"></app-small-spinner>
<div class="row">
    <div class="col-lg-4 col-md-6" *ngFor="let course of courses">
        <app-my-course-item [hidePrice]="true" [course]="course" (routeToCourseDetail) = "routeToCourseDetail($event)">
        </app-my-course-item>
    </div>
</div>